import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Subscription } from 'rxjs/Subscription';

import { BudgetService } from '../service/budget.service';
import { CashFlowService } from '../service/cashflow.service';
import { CompanyService } from '../service/company.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { OtherService } from '../service/other.service';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-print-operatingexpenses',
  templateUrl: './print-operatingexpenses.component.html',
  styleUrls: ['../operatingexpenses/operatingexpenses.component.css'],
})
export default class PrintOperatingexpensesComponent implements OnInit {
  constructor(
    private cashflowservice: CashFlowService,
    private operatingexpensesService: OperatingexpensesService,
    private otherService: OtherService,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private toastr: ToastsManager,
  ) {
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.showInstructions = false;
    this.getCompanyData();
    this.getProjectData();
    this.getRecords(this.year);
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() opexEmit: EventEmitter<any> = new EventEmitter();

  @Output() otherEmitOpex: EventEmitter<any> = new EventEmitter();

  @Output() projectEmitOpex: EventEmitter<any> = new EventEmitter();

  @Output() tenYearEmitOpex: EventEmitter<any> = new EventEmitter();

  @Output() occupiedEmitOpex: EventEmitter<any> = new EventEmitter();

  @Output() occupiedTenYearEmitOpex: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES
  Math: any;

  projectId = '';

  companyId = '';

  companyLogoUrl = '';

  alphabets: any = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];

  paginations: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  // PROJECT DATA PAGE'S VARIABLES
  otherPayrollFieldValues = [];

  projectName = '';

  inflation_rate: number;

  licensed_beds: number;

  start_up_month: number = 1;

  bedrate = 0;

  average_hourly_wage = 0;

  average_night_shift_hours = 0;

  food_cost = 0;

  // OPERATING EXPENSES PAGES'S VARIABLES
  year: number = 1;

  operating_expenses_id = '';

  occupied_beds = 0;

  total_occupied_beds = 0;

  gross_operating_income: number;

  total_goi = 0;

  management_fee: number;

  management_fee_initial: number;

  total_management_fee = 0;

  average_management_fee = 0;

  manager_salary = 0;

  manager_salary_initial = 0;

  total_manager_salary = 0;

  average_manager_salary = 0;

  manager_salary_percent_goi: number;

  manager_salary_percent_goi_initial: number;

  total_manager_salary_percent_goi = 0;

  average_manager_salary_percent_goi = 0;

  workers_comp_factor = 0;

  workers_comp_factor_initial = 0;

  caregivers_wages = 0;

  total_caregiver_wages = 0;

  chef = 0;

  chef_initial = 0;

  total_chef = 0;

  average_chef = 0;

  cleaning_staff = 0;

  cleaning_staff_initial = 0;

  total_cleaning_staff = 0;

  average_cleaning_staff = 0;

  rent = 0;

  rent_initial = 0;

  total_rent = 0;

  average_rent = 0;

  taxes = 0;

  taxes_initial = 0;

  total_taxes = 0;

  average_taxes = 0;

  insurance_property = 0;

  insurance_property_initial = 0;

  total_insurance_property = 0;

  average_insurance_property = 0;

  gas = 0;

  gas_initial = 0;

  total_gas = 0;

  average_gas = 0;

  water_sewer = 0;

  water_sewer_initial = 0;

  total_water_sewer = 0;

  average_water_sewer = 0;

  electric = 0;

  electric_initial = 0;

  total_electric = 0;

  average_electric = 0;

  garbage_removal = 0;

  garbage_removal_initial = 0;

  total_garbage_removal = 0;

  average_garbage_removal = 0;

  landscaping_plowing = 0;

  landscaping_plowing_initial = 0;

  total_landscaping_plowing = 0;

  average_landscaping_plowing = 0;

  exterminator = 0;

  exterminator_initial = 0;

  total_exterminator = 0;

  average_exterminator = 0;

  business_license_renewal = 0;

  business_license_renewal_initial = 0;

  total_business_license_renewal = 0;

  average_business_license_renewal = 0;

  accounting_payroll_services = 0;

  accounting_payroll_services_initial = 0;

  total_accounting_payroll_services = 0;

  average_accounting_payroll_services = 0;

  hoa_fees = 0;

  hoa_fees_initial = 0;

  total_hoa_fees = 0;

  average_hoa_fees = 0;

  food = 0;

  food_initial = 0;

  total_food = 0;

  average_food = 0;

  housekeeping_supplies = 0;

  housekeeping_supplies_initial = 0;

  total_housekeeping_supplies = 0;

  average_housekeeping_supplies = 0;

  office_supplies = 0;

  office_supplies_initial = 0;

  total_office_supplies = 0;

  average_office_supplies = 0;

  security_monitoring = 0;

  security_monitoring_initial = 0;

  total_security_monitoring = 0;

  average_security_monitoring = 0;

  recreational_activities = 0;

  recreational_activities_initial = 0;

  total_recreational_activities = 0;

  average_recreational_activities = 0;

  website_advertising = 0;

  website_advertising_initial = 0;

  total_website_advertising = 0;

  average_website_advertising = 0;

  referral_fees_start_up = 0;

  total_referral_fees_start_up = 0;

  average_referral_fees_start_up = 0;

  referral_fees_ongoing = 0;

  referral_fees_ongoing_initial = 0;

  total_referral_fees_ongoing = 0;

  average_referral_fees_ongoing = 0;

  insurance_liability = 0;

  insurance_liability_initial = 0;

  total_insurance_liability = 0;

  average_insurance_liability = 0;

  cable_internet_phone_newspapers = 0;

  cable_internet_phone_newspapers_initial = 0;

  total_cable_internet_phone_newspapers = 0;

  average_cable_internet_phone_newspapers = 0;

  repairs_maintenance = 0;

  repairs_maintenance_initial = 0;

  total_repairs_maintenance = 0;

  average_repairs_maintenance = 0;

  transportation = 0;

  transportation_initial = 0;

  total_transportation = 0;

  average_transportation = 0;

  furniture_lease = 0;

  furniture_lease_initial = 0;

  total_furniture_lease = 0;

  average_furniture_lease = 0;

  membership_fees = 0;

  membership_fees_initial = 0;

  total_membership_fees = 0;

  average_membership_fees = 0;

  // OTHER FIELDS ARRAYS
  otherFieldsPayrollExpenses: any = [];

  otherFieldsPayrollExpensesFirstYearData: any = [];

  otherFieldsPayrollExpensesSecondYearData: any = [];

  otherFieldsPayrollExpensesThirdYearData: any = [];

  otherFieldsGeneralExpenses: any = [];

  otherFieldsGeneralExpensesFirstYearData: any = [];

  otherFieldsGeneralExpensesSecondYearData: any = [];

  otherFieldsGeneralExpensesThirdYearData: any = [];

  otherFieldsMiscExpenses: any = [];

  otherFieldsMiscExpensesFirstYearData: any = [];

  otherFieldsMiscExpensesSecondYearData: any = [];

  otherFieldsMiscExpensesThirdYearData: any = [];

  // OTHER FIELDS TOTAL VARIABLES
  payrollOtherValuesSum = 0;

  payrollOtherValuesTotal = 0;

  generalOtherValuesSum = 0;

  generalOtherValuesTotal = 0;

  miscOtherValuesSum = 0;

  miscOtherValuesTotal = 0;

  // TEN YEAR RECORDS ARRAYS
  goiTenYearsData = [];

  payrollTenYearsData = [];

  payrollTenYearsDataGoi = [];

  generalTenYearsData = [];

  generalTenYearsDataGoi = [];

  opexTenYearsData = [];

  opexTenYearsDataGoi = [];

  netOperatingIncomeTenYearsData: any = [];

  debtServiceTenYearsData = [];

  netProfitTenYearsData = [];

  netProfitPercentTenYearsData = [];

  debtServiceMultipleTenYearsData = [];

  // TEN YEAR RECORDS ARRAYS FOR CUMULATIVE
  // Indexes into the XXXCumulative arrays
  readonly YEARS1TO3_INDEX = 0;

  readonly YEARS1TO5_INDEX = 1;

  readonly YEARS1TO7_INDEX = 2;

  readonly YEARS1TO10_INDEX = 3;

  goiDataCumulative: any = [];

  payrollDataCumulative: any = [];

  payrollDataGoiCumulative: any = [];

  generalDataCumulative: any = [];

  generalDataGoiCumulative: any = [];

  opexDataCumulative: any = [];

  opexDataGoiCumulative: any = [];

  netOperatingIncomeCumulative: any = [];

  debtServiceCumulative: any = [];

  netProfitCumulative: any = [];

  netProfitPercentCumulative: any = [];

  debtServiceCoverageCumulative: any = [];

  // VARIABLES FOR TOTAL OF TEN YEAR RECORDS
  tenYearsGoiTotal: number;

  tenYearsPayrollTotal: number;

  tenYearsPayrollGoiTotal: number;

  tenYearsGeneralTotal: number;

  tenYearsGeneralGoiTotal: number;

  tenYearsOpexTotal: number;

  tenYearsOpexGoiTotal: number;

  tenYearsNetOperatingIncomeTotal: number;

  tenYearsDebtServiceTotal: number;

  tenYearsNetProfitTotal: number;

  tenYearsNetProfitPercentTotal: number;

  tenYearsNetProfitPercentAverage: number;

  tenYearsDebtServiceCoverageTotal: number;

  tenYearsDebtServiceCoverageAverage: number;

  showPayrollNumbering: boolean;

  showGeneralNumbering: boolean;

  showMiscNumbering: boolean;

  occupiedBedsValues: any = [];

  tenYearsPayrolldata: any = {};

  totalPayroll = 0;

  totalCaregiverWages = 0;

  totalStartUp = 0;

  payrollDataCalculatedTotal = 0;

  payrollDataCalculated = [];

  generalDataCalculatedTotal = 0;

  generalDataCalculated = [];

  opexDataCalculatedTotal = 0;

  opexDataCalculated = [];

  payrollGOICalculatedTotal = 0;

  payrollGOICalculated = [];

  generalGOICalculatedTotal = 0;

  generalGOICalculated = [];

  opexGOICalculatedTotal = 0;

  opexGOICalculated = [];

  payrollTenYears: any = [];

  generalTenYears: any = [];

  opexTenYears: any = [];

  bedsTenYears: any = [];

  payrollTenYearsTotal = 0;

  generalTenYearsTotal = 0;

  opexTenYearsTotal = 0;

  bedsTenYearsTotal = 0;

  payrollDataYearly = [];

  payrollDataYearlyTotal = 0;

  payrollDataYearlyTotalForOther = 0;

  payrollDataYearlyGoi = [];

  payrollDataYearlyGoiTotal = 0;

  generalDataYearly = []; // The array of months shown in the "TOTAL General Expenses" row of the Expense Summary table

  generalDataYearlyTotal = 0; // The value for the Total column of the "TOTAL General Expenses" row of the Expense Summary table

  generalDataYearlyTotalForOther = 0;

  generalDataYearlyGoi = [];

  generalDataYearlyGoiTotal = 0;

  opexDataYearly = [];

  opexDataYearlyTotal = 0;

  opexDataYearlyGoi = [];

  opexDataYearlyGoiTotal = 0;

  ceiledStartUpYear = 0;

  otherFlag = false;

  tenYearsParsed = false;

  // DECLARATION OF OBJECT TO SHOW TEN YEARS DATA IN PRINTING AS WELL AS IN SCREEN
  parentObject: any = {
    payrollDataYearlyGoi: new Array(),
    payrollDataYearly: new Array(),
    generalDataYearly: new Array(),
    generalDataYearlyGoi: new Array(),
    opexDataYearly: new Array(),
    opexDataYearlyGoi: new Array(),
    otherFieldsPayrollExpenses: new Array(),
    otherFieldsPayrollExpensesFirstYearData: new Array(),
    otherFieldsPayrollExpensesSecondYearData: new Array(),
    otherFieldsPayrollExpensesThirdYearData: new Array(),
    otherFieldsGeneralExpenses: new Array(),
    otherFieldsGeneralExpensesFirstYearData: new Array(),
    otherFieldsGeneralExpensesSecondYearData: new Array(),
    otherFieldsGeneralExpensesThirdYearData: new Array(),
    otherFieldsMiscExpensesFirstYearData: new Array(),
    otherFieldsMiscExpensesSecondYearData: new Array(),
    otherFieldsMiscExpensesThirdYearData: new Array(),
    inputData: new Array(),
    data: new Array(),
    tables: new Array(2),
  };

  showInstructions: boolean;

  ngOnInit() {}

  // GET COMPANY DATA
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // GET SAVED PROJECT DATA FROM DB
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.start_up_month = projectData.data[0].start_up_month;
      this.ceiledStartUpYear = Math.ceil(this.start_up_month / 12);
      this.average_night_shift_hours = projectData.data[0].average_night_shift_hours;
      this.food_cost = projectData.data[0].food_cost;
      this.average_hourly_wage = projectData.data[0].average_hourly_wage;
      this.licensed_beds = projectData.data[0].licensed_beds;
      this.inflation_rate = projectData.data[0].inflation_rate;
      this.bedrate =
        projectData.data[0].selection_type === 'other'
          ? projectData.data[0].bed_rate_other
          : projectData.data[0].bed_rate;
      this.parentObject.year = this.year;
      this.parentObject.food_cost = this.food_cost;
      this.parentObject.start_up_month = this.start_up_month;
      this.parentObject.ceiledStartUpYear = this.ceiledStartUpYear;
      this.projectEmitOpex.emit({ projectEmitOpex: true });
      //        console.log(`Parent object: `, this.parentObject);
    });
  }

  // CALCULATE TEN YEARS DATA AT BACKEND IN "calculateTenYears" FUNCTION OF PROJECT CONTROLLER AND SAVE INTO DB. THIS FUNCTION WILL ALWAYS RUN WHEN COME TO OPEX PAGE
  calculateTenYears(): Promise<void> {
    return new Promise((resolve) => {
      const data = {
        project_id: this.projectId,
        year: this.year,
        inflation_rate: this.inflation_rate,
        start_up_month: this.start_up_month,
      };

      this.projectService.calculateTenYears(data).subscribe(() => {
        this.tenYearsParsed = true;
        this.tenYearEmitOpex.emit({ tenYearEmitOpex: true });
        resolve();
      });
    });
  }

  // TO GET DATA OF 120 MONTHS AND PUSH INTO ARRAYS ACCORDING TO YEAR AND CALCULATE TOTALS FOR YEAR WISE AND ALSO CALCULATE EXPENSES SUMMARY
  getOccupiedBeds() {
    const { projectId } = this;
    const payrollGOICalculated = [];
    const occupiedBedsQueryData = { projectId, year: this.year };
    this.projectService.getOccupiedBeds(occupiedBedsQueryData).subscribe((res) => {
      let totalStartUp = 0;
      let total = 0;
      const payrollData = {};
      const totalPayrollData = [];
      const totalPayrollGoi = [];

      const totalgeneralData = [];
      const totalgeneralDataGoi = [];

      const totalOpExData = [];
      const totalOpExDataGoi = [];

      let totalCaregiverWages = 0;
      this.occupiedBedsValues = res.data;
      let totalOpeBeds = 0;
      let totalGoi = 0;
      let foodTotal = 0;
      let otherValueSumPayroll = 0;
      let otherValueSumMisc = 0;
      this.parentObject.data = res.data;
      // CALCULATING FOR CURRENT YEAR ONLY
      for (let i = 0; i < res.data.length; i++) {
        const { value } = res.data[i];

        // calculate total beds occupied starts here
        totalOpeBeds += +value;
        // calculate total beds occupied ends here

        // calculate total goi starts here
        totalGoi += +res.data[i].goi;
        // calculate total goi ends here

        // calculate total food starts here
        if (+res.data[i].month >= this.start_up_month) {
          foodTotal += +res.data[i].food;
        } else {
          foodTotal += +0;
        }
        // calculate total food ends here

        totalCaregiverWages += +res.data[i].caregiver_wages;
        // ALSO CALCULATE TOTAL WRT START UP MONTH
        if (this.start_up_month <= res.data[i].month) {
          totalStartUp += +res.data[i].referral_fees_start_up;
          // totalCaregiverWages += +this.average_hourly_wage * 30 *((res.data[i].caregivers_day*(24-this.average_night_shift_hours)) + (res.data[i].caregivers_night*this.average_night_shift_hours));
        }

        total += +value;
        this.payrollDataCalculated[i] = res.data[i].payroll;

        this.generalDataCalculated[i] = res.data[i].general;

        this.opexDataCalculated[i] = res.data[i].opex;
        if (this.bedrate * res.data[i].value > 0) {
          this.payrollGOICalculated[i] =
            (this.payrollDataCalculated[i] / (this.bedrate * res.data[i].value)) * 100;
          this.opexGOICalculated[i] =
            (this.opexDataCalculated[i] / (this.bedrate * res.data[i].value)) * 100;
          this.generalGOICalculated[i] =
            (this.generalDataCalculated[i] / (this.bedrate * res.data[i].value)) * 100;
        } else {
          this.payrollGOICalculated[i] = 0;
          this.opexGOICalculated[i] = 0;
          this.generalGOICalculated[i] = 0;
        }

        // CALCULATION OF PAYROLL DATA POINT 13 STARTS HERE
        let payrollforCurrentYear = 0;
        const currentParsedYear: any = this.year;
        const currentParsedMonth = (currentParsedYear - 1) * 12 + (i + 1);

        if (currentParsedMonth < this.start_up_month) {
          otherValueSumPayroll = 0;
          otherValueSumMisc = 0;
        } else {
          otherValueSumPayroll = this.payrollOtherValuesSum;
          otherValueSumMisc = this.miscOtherValuesSum;
        }
        payrollforCurrentYear = Math.round(
          +res.data[i].management_fee +
            +res.data[i].manager_salary +
            +res.data[i].manager_salary_percent_goi +
            res.data[i].chef +
            +res.data[i].cleaning_staff +
            +res.data[i].caregiver_wages +
            +otherValueSumPayroll
        );

        if (payrollforCurrentYear > 0) {
          totalPayrollData.push(payrollforCurrentYear);
        } else {
          totalPayrollData.push(0);
        }

        if (res.data[i].goi === 0) {
          totalPayrollGoi.push(0);
        } else {
          totalPayrollGoi.push(payrollforCurrentYear / res.data[i].goi);
        }

        // CALCULATION OF PAYROLL DATA POINT 13 ENDS HERE

        // CALCULATION OF GENERAL DATA POINT 45 STARTS HERE
        let generalforCurrentYear = 0;
        generalforCurrentYear =
          +res.data[i].rent +
          +res.data[i].taxes +
          +res.data[i].insurance_property +
          +res.data[i].gas +
          +res.data[i].water_sewer +
          +res.data[i].electric +
          +res.data[i].garbage_removal +
          +res.data[i].landscaping_plowing +
          +res.data[i].exterminator +
          +res.data[i].business_license_renewal +
          +res.data[i].accounting_payroll_services +
          +res.data[i].hoa_fees +
          +res.data[i].food +
          +res.data[i].housekeeping_supplies +
          +res.data[i].office_supplies +
          +res.data[i].security_monitoring +
          +res.data[i].recreational_activities +
          +res.data[i].website_advertising +
          +res.data[i].referral_fees_start_up +
          +res.data[i].referral_fees_ongoing +
          +res.data[i].insurance_liability +
          +res.data[i].cable_internet_phone_newspapers +
          +res.data[i].repairs_maintenance +
          +res.data[i].transportation +
          +res.data[i].furniture_lease +
          +res.data[i].membership_fees +
          +this.generalOtherValuesSum +
          +otherValueSumMisc;
        totalgeneralData.push(generalforCurrentYear);
        if (res.data[i].goi === 0) {
          totalgeneralDataGoi.push(0);
        } else {
          totalgeneralDataGoi.push(generalforCurrentYear / res.data[i].goi);
        }

        // CALCULATION OF GENERAL DATA POINT 45 ENDS HERE

        // CALCULATION OF TOTAL OPERATING EXPENSES STARTS HERE
        let opexforCurrentYear = 0;
        opexforCurrentYear = +payrollforCurrentYear + +generalforCurrentYear;
        // save above values wrt month in yearly records
        opexforCurrentYear = isNaN(opexforCurrentYear) ? 0 : opexforCurrentYear;
        totalOpExData.push(opexforCurrentYear);
        if (res.data[i].goi === 0) {
          totalOpExDataGoi.push(0);
        } else {
          totalOpExDataGoi.push(opexforCurrentYear / res.data[i].goi);
        }
      }

      this.total_referral_fees_start_up = totalStartUp;
      this.payrollDataYearly = totalPayrollData;

      this.payrollDataYearlyTotal = this.payrollDataYearly.reduce((a, b) => a + b, 0);

      this.total_occupied_beds = totalOpeBeds;
      this.total_goi = totalGoi;
      this.total_caregiver_wages = isNaN(totalCaregiverWages) ? 0 : totalCaregiverWages;
      this.total_food = foodTotal;

      this.payrollDataYearlyGoi = totalPayrollGoi;

      this.payrollDataYearlyGoiTotal =
        (this.payrollDataYearlyTotal / 12 / (this.total_goi / 12)) * 100;
      if (isNaN(this.payrollDataYearlyGoiTotal)) {
        this.payrollDataYearlyGoiTotal = 0;
      }

      this.generalDataYearly = totalgeneralData;
      this.generalDataYearlyTotal = this.generalDataYearly.reduce((a, b) => a + b, 0);
      this.generalDataYearlyTotalForOther = this.generalDataYearly.reduce((a, b) => a + b, 0);

      this.generalDataYearlyGoi = totalgeneralDataGoi;
      this.generalDataYearlyGoiTotal =
        (this.generalDataYearlyTotal / 12 / (this.total_goi / 12)) * 100; // this.generalDataYearlyGoi.reduce((a, b) => a + b, 0);
      if (isNaN(this.generalDataYearlyGoiTotal)) {
        this.generalDataYearlyGoiTotal = 0;
      }

      this.opexDataYearly = totalOpExData;
      this.opexDataYearlyTotal = this.opexDataYearly.reduce((a, b) => a + b, 0);

      this.opexDataYearlyGoi = totalOpExDataGoi;
      this.opexDataYearlyGoiTotal = (this.opexDataYearlyTotal / 12 / (this.total_goi / 12)) * 100;
      // this.opexDataYearlyGoi.reduce((a, b) => a + b, 0);
      if (isNaN(this.opexDataYearlyGoiTotal)) {
        this.opexDataYearlyGoiTotal = 0;
      }

      const data = {
        totalGoi: this.total_goi,
        payrollDataYearlyTotal: this.payrollDataYearlyTotal,
        payrollDataYearlyGoi: this.payrollDataYearlyGoiTotal,
        generalDataYearly: this.generalDataYearlyTotal,
        generalDataYearlyGoi: this.generalDataYearlyGoiTotal,
        opexDataYearly: this.opexDataYearlyTotal,
        opexDataYearlyGoi: this.opexDataYearlyGoiTotal,
        totalCaregiverWages,
        year: this.year,
        total_food: this.total_food,
        average_food: this.total_food / 12,
        project_id: this.projectId,
        total_occupied_beds: this.total_occupied_beds,
        total_referral_fees_start_up: this.total_referral_fees_start_up,
      };

      this.occupiedEmitOpex.emit({ occupiedEmitOpex: true });
      this.getOccupiedBedstenYearly();

      this.projectService.updateTotalExpenses(data).subscribe();
    });
  }

  private static calculateCumulativeTotal(
    annualData: Array<number>,
    tenYearTotal: number | undefined
  ): Array<number> {
    const years1To3 = +annualData[0] + +annualData[1] + +annualData[2];
    const years1To5 = years1To3 + +annualData[3] + +annualData[4];
    const years1To7 = years1To5 + +annualData[5] + +annualData[6];
    const years1To10 = tenYearTotal || years1To7 + +annualData[7] + +annualData[8] + +annualData[9];

    const result = [years1To3, years1To5, years1To7, years1To10];
    return result;
  }

  private calculateCumulativePercentOfGoi(cumulativeData: Array<number>): Array<number> {
    const result = [];
    for (let idx = 0; idx <= this.YEARS1TO10_INDEX; idx += 1) {
      let percentOfGoi = (cumulativeData[idx] / this.goiDataCumulative[idx]) * 100;
      percentOfGoi = isFinite(percentOfGoi) ? percentOfGoi : 0;

      result.push(percentOfGoi);
    }

    return result;
  }

  // GET 10 YEARS TOTALS DATA FOR OPERATING EXPENSES YEARS TABLE
  async getOccupiedBedstenYearly() {
    await this.calculateTenYears();

    const { projectId } = this;
    const data = { projectId };

    this.operatingexpensesService.tenYearsRecords(data).subscribe((res) => {
      // EMPTY THE ARRAYS SO THAT THEY ARE NOT POPULATED WITH SAME DATA AS WE START CHANGING START UP MONTH STARTS HERE
      this.goiDataCumulative = [];
      this.payrollDataCumulative = [];
      this.payrollDataGoiCumulative = [];
      this.generalDataCumulative = [];
      this.generalDataGoiCumulative = [];
      this.opexDataCumulative = [];
      this.opexDataGoiCumulative = [];
      this.netOperatingIncomeCumulative = [];

      this.goiTenYearsData = [];
      this.payrollTenYearsData = [];
      this.payrollTenYearsDataGoi = [];
      this.generalTenYearsData = [];
      this.generalTenYearsDataGoi = [];
      this.opexTenYearsData = [];
      this.opexTenYearsDataGoi = [];
      this.netOperatingIncomeTenYearsData = [];
      this.debtServiceTenYearsData = [];
      this.netProfitTenYearsData = [];
      this.netProfitPercentTenYearsData = [];
      this.debtServiceMultipleTenYearsData = [];
      // EMPTY THE ARRAYS SO THAT THEY ARE NOT POPULATED WITH SAME DATA AS WE START CHANGING START UP MONTH ENDS HERE

      for (const yearData of res.data) {
        this.goiTenYearsData.push(Math.round(yearData.total_goi_year));
        this.payrollTenYearsData.push(Math.round(yearData.total_payroll_year));

        let goiValue = yearData.total_payroll_year_goi;
        this.payrollTenYearsDataGoi.push(goiValue);

        this.generalTenYearsData.push(Math.round(yearData.total_general_year));

        goiValue = yearData.total_general_year_goi;
        this.generalTenYearsDataGoi.push(goiValue);

        this.opexTenYearsData.push(Math.round(yearData.total_opex_year));

        this.debtServiceTenYearsData.push(yearData.annualDebtService);

        //
        // Net operating income (NOI) is just the GOI - total operating expenses. It does not have anything to do with debt service.
        // Net PROFIT, however, removes the debt service because you have to pay the loan distributions before you put the remaining
        // money in your pocket. We're calculating NOI here because it is used later in determining the Debt Service Coverage.
        //
        const annualNetOperatingIncome = yearData.total_goi_year - yearData.total_opex_year;
        const netProfit = annualNetOperatingIncome - yearData.annualDebtService;
        this.netProfitTenYearsData.push(netProfit);
        this.netProfitPercentTenYearsData.push(netProfit / goiValue);

        //
        // Calculate the debt service coverage as shown on the Financial Reports. It is just
        // the NOI / debt service (assuming debt service is not zero). We need this on an annual basis.
        //
        const debtServiceMultiple = annualNetOperatingIncome / yearData.annualDebtService;
        this.debtServiceMultipleTenYearsData.push(
          Number.isFinite(debtServiceMultiple) ? debtServiceMultiple : 0
        );

        // opexDataYearlyGoiTotal
        goiValue = yearData.total_opex_year_goi;
        this.opexTenYearsDataGoi.push(goiValue);

        this.netOperatingIncomeTenYearsData.push(Math.round(annualNetOperatingIncome));
      }

      this.tenYearsGoiTotal = this.goiTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsPayrollTotal = this.payrollTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsPayrollGoiTotal = this.payrollTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsGeneralTotal = this.generalTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsGeneralGoiTotal = this.generalTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsOpexTotal = this.opexTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsOpexGoiTotal = this.opexTenYearsDataGoi.reduce((a, b) => a + b, 0);

      this.tenYearsNetOperatingIncomeTotal = this.netOperatingIncomeTenYearsData.reduce(
        (a, b) => a + b,
        0
      );

      this.tenYearsOpexTotal = this.opexTenYearsData.reduce((a, b) => a + b, 0);

      this.tenYearsDebtServiceTotal = this.debtServiceTenYearsData.reduce((a, b) => a + b, 0);

      this.tenYearsNetProfitTotal = this.netProfitTenYearsData.reduce((a, b) => a + b, 0);
      this.tenYearsNetProfitPercentTotal = this.tenYearsNetProfitTotal / this.tenYearsGoiTotal;
      this.tenYearsNetProfitPercentAverage =
        this.tenYearsNetProfitTotal / 10 / (this.tenYearsGoiTotal / 10);

      const tenYearsDebtServiceCoverageTotal =
        this.tenYearsNetOperatingIncomeTotal / this.tenYearsDebtServiceTotal;
      this.tenYearsDebtServiceCoverageTotal = Number.isFinite(tenYearsDebtServiceCoverageTotal)
        ? tenYearsDebtServiceCoverageTotal
        : 0;

      //
      // The Debt Service Coverage average is the NOI average (NOI total / 10 years) divided by the average debt service (tenYearsDebtServiceTotal / 10).
      // This mathematically reduces to just the same as the (NOI total / Debt Service total), so we can just reuse the value from
      // the Debt Service Coverage Total.
      //
      this.tenYearsDebtServiceCoverageAverage = this.tenYearsDebtServiceCoverageTotal;

      //
      // Calculate all of the values for the "Cumutative" table
      //
      this.goiDataCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.goiTenYearsData,
        this.tenYearsGoiTotal
      );
      this.payrollDataCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.payrollTenYearsData,
        this.tenYearsPayrollTotal
      );
      this.payrollDataGoiCumulative = this.calculateCumulativePercentOfGoi(
        this.payrollDataCumulative
      );
      this.generalDataCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.generalTenYearsData,
        this.tenYearsGeneralTotal
      );
      this.generalDataGoiCumulative = this.calculateCumulativePercentOfGoi(
        this.generalDataCumulative
      );
      this.opexDataCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.opexTenYearsData,
        this.tenYearsOpexTotal
      );
      this.opexDataGoiCumulative = this.calculateCumulativePercentOfGoi(this.opexDataCumulative);
      this.netOperatingIncomeCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.netOperatingIncomeTenYearsData,
        this.tenYearsNetOperatingIncomeTotal
      );
      this.debtServiceCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.debtServiceTenYearsData,
        undefined
      );
      this.netProfitCumulative = PrintOperatingexpensesComponent.calculateCumulativeTotal(
        this.netProfitTenYearsData,
        undefined
      );

      //
      // Calculating the cumulative values for the Net Profit % and Debt Service Coverage have to be done off of the cumulative
      // arrays for the values that make up the calculations. We can't just add them up like all of the other fields.
      //
      for (let idx = 0; idx < this.netProfitCumulative.length; idx += 1) {
        this.netProfitPercentCumulative.push(
          this.netProfitCumulative[idx] / this.goiDataCumulative[idx]
        );
        this.debtServiceCoverageCumulative.push(
          this.netOperatingIncomeCumulative[idx] / this.debtServiceCumulative[idx]
        );
      }

      this.parentObject.payrollDataYearly = this.payrollDataYearly;
      this.parentObject.payrollDataYearlyGoi = this.payrollDataYearlyGoi;
      this.parentObject.generalDataYearly = this.generalDataYearly;
      this.parentObject.generalDataYearlyGoi = this.generalDataYearlyGoi;
      this.parentObject.opexDataYearly = this.opexDataYearly;
      this.parentObject.opexDataYearlyGoi = this.opexDataYearlyGoi;
      this.occupiedTenYearEmitOpex.emit({ occupiedTenYearEmitOpex: true });
    });
  }

  // TO GET INPUT FIELDS OF OPEX PAGE THAT ARE STORED INTO DB
  getRecords(year) {
    this.year = year;
    this.operatingexpensesService.getRecords(this.projectId, this.year).subscribe(async (data) => {
      // console.log('Read opex data');
      if (data.messageId === 200) {
        this.operating_expenses_id = data.data[0]._id;
        this.occupied_beds = data.data[0].occupied_beds;

        this.total_goi = data.data[0].total_goi;
        this.total_occupied_beds = data.data[0].total_occupied_beds;

        this.total_management_fee = data.data[0].total_management_fee;
        this.average_management_fee = data.data[0].average_management_fee;

        this.management_fee = data.data[0].management_fee;
        this.management_fee_initial = data.data[0].management_fee;

        this.manager_salary = data.data[0].manager_salary;
        this.manager_salary_initial = data.data[0].manager_salary;

        this.total_manager_salary = data.data[0].total_manager_salary;
        this.average_manager_salary = data.data[0].average_manager_salary;

        this.manager_salary_percent_goi = data.data[0].manager_salary_percent_goi;
        this.manager_salary_percent_goi_initial = data.data[0].manager_salary_percent_goi;

        this.total_manager_salary_percent_goi = data.data[0].total_manager_salary_percent_goi;
        this.average_manager_salary_percent_goi = data.data[0].average_manager_salary_percent_goi;

        this.workers_comp_factor = data.data[0].workers_comp_factor;
        this.workers_comp_factor_initial = data.data[0].workers_comp_factor;

        this.caregivers_wages = data.data[0].caregivers_wages;

        this.chef = data.data[0].chef;
        this.chef_initial = data.data[0].chef;
        this.total_chef = data.data[0].total_chef;
        this.average_chef = data.data[0].average_chef;

        this.cleaning_staff = data.data[0].cleaning_staff;
        this.cleaning_staff_initial = data.data[0].cleaning_staff;
        this.total_cleaning_staff = data.data[0].total_cleaning_staff;
        this.average_cleaning_staff = data.data[0].average_cleaning_staff;

        this.rent = data.data[0].rent;
        this.rent_initial = data.data[0].rent;
        this.total_rent = data.data[0].total_rent;
        this.average_rent = data.data[0].average_rent;

        this.taxes = data.data[0].taxes;
        this.taxes_initial = data.data[0].taxes;
        this.total_taxes = data.data[0].total_taxes;
        this.average_taxes = data.data[0].average_taxes;

        this.insurance_property = data.data[0].insurance_property;
        this.insurance_property_initial = data.data[0].insurance_property;
        this.total_insurance_property = data.data[0].total_insurance_property;
        this.average_insurance_property = data.data[0].average_insurance_property;

        this.gas = data.data[0].gas;
        this.gas_initial = data.data[0].gas;
        this.total_gas = data.data[0].total_gas;
        this.average_gas = data.data[0].average_gas;

        this.water_sewer = data.data[0].water_sewer;
        this.water_sewer_initial = data.data[0].water_sewer;
        this.total_water_sewer = data.data[0].total_water_sewer;
        this.average_water_sewer = data.data[0].average_water_sewer;

        this.electric = data.data[0].electric;
        this.electric_initial = data.data[0].electric;
        this.total_electric = data.data[0].total_electric;
        this.average_electric = data.data[0].average_electric;

        this.garbage_removal = data.data[0].garbage_removal;
        this.garbage_removal_initial = data.data[0].garbage_removal;
        this.total_garbage_removal = data.data[0].total_garbage_removal;
        this.average_garbage_removal = data.data[0].average_garbage_removal;

        this.landscaping_plowing = data.data[0].landscaping_plowing;
        this.landscaping_plowing_initial = data.data[0].landscaping_plowing;
        this.total_landscaping_plowing = data.data[0].total_landscaping_plowing;
        this.average_landscaping_plowing = data.data[0].average_landscaping_plowing;

        this.exterminator = data.data[0].exterminator;
        this.exterminator_initial = data.data[0].exterminator;
        this.total_exterminator = data.data[0].total_exterminator;
        this.average_exterminator = data.data[0].average_exterminator;

        this.business_license_renewal = data.data[0].business_license_renewal;
        this.business_license_renewal_initial = data.data[0].business_license_renewal;
        this.total_business_license_renewal = data.data[0].total_business_license_renewal;
        this.average_business_license_renewal = data.data[0].average_business_license_renewal;

        this.accounting_payroll_services = data.data[0].accounting_payroll_services;
        this.accounting_payroll_services_initial = data.data[0].accounting_payroll_services;
        this.total_accounting_payroll_services = data.data[0].total_accounting_payroll_services;
        this.average_accounting_payroll_services = data.data[0].average_accounting_payroll_services;

        this.hoa_fees = data.data[0].hoa_fees;
        this.hoa_fees_initial = data.data[0].hoa_fees;
        this.total_hoa_fees = data.data[0].total_hoa_fees;
        this.average_hoa_fees = data.data[0].average_hoa_fees;

        this.food = data.data[0].food;
        this.food_initial = data.data[0].food;

        this.housekeeping_supplies = data.data[0].housekeeping_supplies;
        this.housekeeping_supplies_initial = data.data[0].housekeeping_supplies;
        this.total_housekeeping_supplies = data.data[0].total_housekeeping_supplies;
        this.average_housekeeping_supplies = data.data[0].housekeeping_supplies;

        this.office_supplies = data.data[0].office_supplies;
        this.office_supplies_initial = data.data[0].office_supplies;
        this.total_office_supplies = data.data[0].total_office_supplies;
        this.average_office_supplies = data.data[0].average_office_supplies;

        this.security_monitoring = data.data[0].security_monitoring;
        this.security_monitoring_initial = data.data[0].security_monitoring;
        this.total_security_monitoring = data.data[0].total_security_monitoring;
        this.average_security_monitoring = data.data[0].average_security_monitoring;

        this.recreational_activities = data.data[0].recreational_activities;
        this.recreational_activities_initial = data.data[0].recreational_activities;
        this.total_recreational_activities = data.data[0].total_recreational_activities;
        this.average_recreational_activities = data.data[0].average_recreational_activities;

        this.website_advertising = data.data[0].website_advertising;
        this.website_advertising_initial = data.data[0].website_advertising;
        this.total_website_advertising = data.data[0].total_website_advertising;
        this.average_website_advertising = data.data[0].average_website_advertising;

        this.referral_fees_start_up = data.data[0].referral_fees_start_up;
        this.total_referral_fees_start_up = data.data[0].total_referral_fees_start_up;
        this.average_referral_fees_start_up = data.data[0].average_referral_fees_start_up;

        this.referral_fees_ongoing = data.data[0].referral_fees_ongoing;
        this.referral_fees_ongoing_initial = data.data[0].referral_fees_ongoing;
        this.total_referral_fees_ongoing = data.data[0].total_referral_fees_ongoing;
        this.average_referral_fees_ongoing = data.data[0].average_referral_fees_ongoing;

        this.insurance_liability = data.data[0].insurance_liability;
        this.insurance_liability_initial = data.data[0].insurance_liability;
        this.total_insurance_liability = data.data[0].total_insurance_liability;
        this.average_insurance_liability = data.data[0].average_insurance_liability;

        this.cable_internet_phone_newspapers = data.data[0].cable_internet_phone_newspapers;
        this.cable_internet_phone_newspapers_initial = data.data[0].cable_internet_phone_newspapers;
        this.total_cable_internet_phone_newspapers =
          data.data[0].total_cable_internet_phone_newspapers;
        this.average_cable_internet_phone_newspapers =
          data.data[0].average_cable_internet_phone_newspapers;

        this.repairs_maintenance = data.data[0].repairs_maintenance;
        this.repairs_maintenance_initial = data.data[0].repairs_maintenance;
        this.total_repairs_maintenance = data.data[0].total_repairs_maintenance;
        this.average_repairs_maintenance = data.data[0].average_repairs_maintenance;

        this.transportation = data.data[0].transportation;
        this.transportation_initial = data.data[0].transportation;
        this.total_transportation = data.data[0].total_transportation;
        this.average_transportation = data.data[0].average_transportation;

        this.furniture_lease = data.data[0].furniture_lease;
        this.furniture_lease_initial = data.data[0].furniture_lease;
        this.total_furniture_lease = data.data[0].total_furniture_lease;
        this.average_furniture_lease = data.data[0].average_furniture_lease;

        this.membership_fees = data.data[0].membership_fees;
        this.membership_fees_initial = data.data[0].membership_fees;
        this.total_membership_fees = data.data[0].total_membership_fees;
        this.average_membership_fees = data.data[0].average_membership_fees;
      }
      // TO GET OTHER FIELDS
      await this.getOtherFields();

      await this.getOccupiedBeds();

      await this.opexEmit.emit({ opexEmit: true });
    });
  }

  // TO UPDATE VALUES INTO DB ONCHANGE OF OPEX INPUT FIELDS
  changeThis(event, fieldName) {
    const value = this.replaceDollarsCommasPercentages(event.target.value);
    const oldValue = this.workers_comp_factor_initial;
    const _id = event.target.id;
    const data = {
      project_id: this.projectId,
      fieldName,
      value,
      year: this.year,
      workers_comp_factor_initial: this.workers_comp_factor_initial,
      fieldname: fieldName,
      licensed_beds: this.licensed_beds,
      start_up_month: this.start_up_month,
      inflation_rate: this.inflation_rate,
    };

    if (fieldName === 'management_fee') {
      if (value === this.management_fee_initial) {
        return;
      }
      this.management_fee_initial = value;
    } else if (fieldName === 'manager_salary') {
      if (value === this.manager_salary_initial) {
        return;
      }
      this.manager_salary_initial = value;
    } else if (fieldName === 'manager_salary_percent_goi') {
      if (value === this.manager_salary_percent_goi_initial) {
        return;
      }
      this.manager_salary_percent_goi_initial = value;
    } else if (fieldName === 'workers_comp_factor') {
      if (value === this.workers_comp_factor_initial) {
        return;
      }
      this.workers_comp_factor_initial = value;
    } else if (fieldName === 'chef') {
      if (value === this.chef_initial) {
        return;
      }
      this.chef_initial = value;
    } else if (fieldName === 'cleaning_staff') {
      if (value === this.cleaning_staff_initial) {
        return;
      }
      this.cleaning_staff_initial = value;
    } else if (fieldName === 'rent') {
      if (value === this.rent_initial) {
        return;
      }
      this.rent_initial = value;
    } else if (fieldName === 'taxes') {
      if (value === this.taxes_initial) {
        return;
      }
      this.taxes_initial = value;
    } else if (fieldName === 'insurance_property') {
      if (value === this.insurance_property_initial) {
        return;
      }
      this.insurance_property_initial = value;
    } else if (fieldName === 'gas') {
      if (value === this.gas_initial) {
        return;
      }
      this.gas_initial = value;
    } else if (fieldName === 'water_sewer') {
      if (value === this.water_sewer_initial) {
        return;
      }
      this.water_sewer_initial = value;
    } else if (fieldName === 'electric') {
      if (value === this.electric_initial) {
        return;
      }
      this.electric_initial = value;
    } else if (fieldName === 'garbage_removal') {
      if (value === this.garbage_removal_initial) {
        return;
      }
      this.garbage_removal_initial = value;
    } else if (fieldName === 'landscaping_plowing') {
      if (value === this.landscaping_plowing_initial) {
        return;
      }
      this.landscaping_plowing_initial = value;
    } else if (fieldName === 'exterminator') {
      if (value === this.exterminator_initial) {
        return;
      }
      this.exterminator_initial = value;
    } else if (fieldName === 'business_license_renewal') {
      if (value === this.business_license_renewal_initial) {
        return;
      }
      this.business_license_renewal_initial = value;
    } else if (fieldName === 'accounting_payroll_services') {
      if (value === this.accounting_payroll_services_initial) {
        return;
      }
      this.accounting_payroll_services_initial = value;
    } else if (fieldName === 'hoa_fees') {
      if (value === this.hoa_fees_initial) {
        return;
      }
      this.hoa_fees_initial = value;
    } else if (fieldName === 'food') {
      if (value === this.food_initial) {
        return;
      }
      this.food_initial = value;
    } else if (fieldName === 'housekeeping_supplies') {
      if (value === this.housekeeping_supplies_initial) {
        return;
      }
      this.housekeeping_supplies_initial = value;
    } else if (fieldName === 'office_supplies') {
      if (value === this.office_supplies_initial) {
        return;
      }
      this.office_supplies_initial = value;
    } else if (fieldName === 'security_monitoring') {
      if (value === this.security_monitoring_initial) {
        return;
      }
      this.security_monitoring_initial = value;
    } else if (fieldName === 'recreational_activities') {
      if (value === this.recreational_activities_initial) {
        return;
      }
      this.recreational_activities_initial = value;
    } else if (fieldName === 'website_advertising') {
      if (value === this.website_advertising_initial) {
        return;
      }
      this.website_advertising_initial = value;
    } else if (fieldName === 'referral_fees_ongoing') {
      if (value === this.referral_fees_ongoing_initial) {
        return;
      }
      this.referral_fees_ongoing_initial = value;
    } else if (fieldName === 'insurance_liability') {
      if (value === this.insurance_liability_initial) {
        return;
      }
      this.insurance_liability_initial = value;
    } else if (fieldName === 'cable_internet_phone_newspapers') {
      if (value === this.cable_internet_phone_newspapers_initial) {
        return;
      }
      this.cable_internet_phone_newspapers_initial = value;
    } else if (fieldName === 'repairs_maintenance') {
      if (value === this.repairs_maintenance_initial) {
        return;
      }
      this.repairs_maintenance_initial = value;
    } else if (fieldName === 'transportation') {
      if (value === this.transportation_initial) {
        return;
      }
      this.transportation_initial = value;
    } else if (fieldName === 'furniture_lease') {
      if (value === this.furniture_lease_initial) {
        return;
      }
      this.furniture_lease_initial = value;
    } else if (fieldName === 'membership_fees') {
      if (value === this.membership_fees_initial) {
        return;
      }
      this.membership_fees_initial = value;
    }
    // console.log("data",data);
    this.operatingexpensesService.updateValue(data).subscribe(
      async (opExUpdateResponse) => {
        this.getOccupiedBeds();
        const data1 = { project_id: this.projectId, value, oldValue, year: this.year };
        if (fieldName === 'workers_comp_factor') {
          this.projectService.updateCareGiverWages(data1).subscribe((res) => {});
        }
        if (opExUpdateResponse.messageId === 200) {
          await this.getRecords(this.year);
        }
      },
      (err) => {
        this.toastr.error(err.message, 'Error');
      }
    );
  }

  // ############## OTHER FIELDS TASKS ################//
  // **************** ADD OTHER FIELDS ******************/
  addInputField(parent, child) {
    const data = { projectId: this.projectId, year: this.year };
    const self = this;
    let array = [];

    this.otherService.saveOtherField(parent, child, data).subscribe(
      () => {
        this.clearData();
        this.getOtherFields().then(() => {
          if (child === 'payroll_expenses') {
            array = self.otherFieldsPayrollExpenses;
          } else if (child === 'general_expenses') {
            array = self.otherFieldsGeneralExpenses;
          } else if (child === 'misc_expenses') {
            array = self.otherFieldsMiscExpenses;
          }
          setTimeout(() => {
            document.getElementById(`label${child}${array.length - 1}`).focus();
          }, 100);
        });
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  calculateOtherValue(otherObj, year, inflationRate, otherFieldsArray): number {
    if (year >= otherObj.selected_year) {
      const yearValue: any = year;
      const power = yearValue - otherObj.selected_year;
      const inflatedValue = (100 + inflationRate) / 100;
      const miscValueOther = Math.ceil(otherObj.field_value * Math.pow(inflatedValue, power));
      otherObj.inflated_value = miscValueOther;
      otherFieldsArray.push(otherObj);
      return miscValueOther;
    }

    otherObj.field_value = 0;
    otherObj.inflated_value = 0;
    otherFieldsArray.push(otherObj);
    return otherObj.field_value;
  }

  // ****************GET OTHER FIELDS ******************/
  getOtherFields(): Promise<boolean> {
    // console.log('getOtherFields');
    let payrollSum = 0;
    const payroll = [];
    let generalSum = 0;
    const general = [];
    let miscSum = 0;
    const misc = [];

    return new Promise((resolve, reject) => {
      this.otherService.getOtherFields(this.projectId, 'operatingexpenses').subscribe((res) => {
        if (res.data.length === 0) {
          this.showPayrollNumbering = true;
          this.showGeneralNumbering = true;
          this.showMiscNumbering = true;
        }
        this.clearData();

        for (const otherObj of res.data) {
          // console.log('otherObj',otherObj.selected_year);
          if (otherObj.child === 'payroll_expenses') {
            // IN ORDER TO GET SUM OF PAYROLL
            const clone = { ...otherObj };
            payrollSum += this.calculateOtherValue(
              clone,
              this.year,
              this.inflation_rate,
              this.otherFieldsPayrollExpenses
            );

            // IN ORDER TO GET TOTAL PAYROLL OTHER FIELDS
            payroll.push(clone.field_value);

            //
            // Also calculate the values for years 1-3 regardless of what year is selected in the UI (i.e., this.year), so that
            // the printout will always have the data it needs for displaying the first three years of data correctly.
            //
            const yearOne = { ...otherObj };
            this.calculateOtherValue(
              yearOne,
              1,
              this.inflation_rate,
              this.otherFieldsPayrollExpensesFirstYearData
            );
            const yearTwo = { ...otherObj };
            this.calculateOtherValue(
              yearTwo,
              2,
              this.inflation_rate,
              this.otherFieldsPayrollExpensesSecondYearData
            );
            const yearThree = { ...otherObj };
            this.calculateOtherValue(
              yearThree,
              3,
              this.inflation_rate,
              this.otherFieldsPayrollExpensesThirdYearData
            );
          } else if (otherObj.child === 'general_expenses') {
            // IN ORDER TO GET SUM OF GENERAL
            const clone = { ...otherObj };
            generalSum += this.calculateOtherValue(
              clone,
              this.year,
              this.inflation_rate,
              this.otherFieldsGeneralExpenses
            );

            // IN ORDER TO GET TOTAL GENERAL OTHER FIELDS
            general.push(clone.field_value);

            //
            // Also calculate the values for years 1 and 2 regardless of what year is selected in the UI (i.e., this.year), so that
            // the printout will always have the data it needs for displaying the first two years of data correctly.
            //
            const yearOne = { ...otherObj };
            this.calculateOtherValue(
              yearOne,
              1,
              this.inflation_rate,
              this.otherFieldsGeneralExpensesFirstYearData
            );
            const yearTwo = { ...otherObj };
            this.calculateOtherValue(
              yearTwo,
              2,
              this.inflation_rate,
              this.otherFieldsGeneralExpensesSecondYearData
            );
            const yearThree = { ...otherObj };
            this.calculateOtherValue(
              yearThree,
              3,
              this.inflation_rate,
              this.otherFieldsGeneralExpensesThirdYearData
            );
          } else if (otherObj.child === 'misc_expenses') {
            //              console.log(`got misc expenses data: ${JSON.stringify(otherObj, null, 2)}`);

            // IN ORDER TO GET SUM OF MISC
            const clone = { ...otherObj };
            miscSum += this.calculateOtherValue(
              clone,
              this.year,
              this.inflation_rate,
              this.otherFieldsMiscExpenses
            );
            //              console.log(`misc expenses data after processing: ${JSON.stringify(clone, null, 2)}`);

            // IN ORDER TO GET TOTAL MISC OTHER FIELDS
            misc.push(clone.field_value);

            //
            // Also calculate the values for years 1 and 2 regardless of what year is selected in the UI (i.e., this.year), so that
            // the printout will always have the data it needs for displaying the first two years of data correctly.
            //
            const yearOne = { ...otherObj };
            this.calculateOtherValue(
              yearOne,
              1,
              this.inflation_rate,
              this.otherFieldsMiscExpensesFirstYearData
            );
            const yearTwo = { ...otherObj };
            this.calculateOtherValue(
              yearTwo,
              2,
              this.inflation_rate,
              this.otherFieldsMiscExpensesSecondYearData
            );
            const yearThree = { ...otherObj };
            this.calculateOtherValue(
              yearThree,
              3,
              this.inflation_rate,
              this.otherFieldsMiscExpensesThirdYearData
            );
          }
        }
        //          console.log('this.otherFieldsMiscExpenses', this.otherFieldsMiscExpenses);
        //          console.log('this.otherFieldsMiscExpensesFirstYearData', this.otherFieldsMiscExpensesFirstYearData);
        //          console.log('this.otherFieldsMiscExpensesSecondYearData', this.otherFieldsMiscExpensesSecondYearData);
        //          console.log('this.otherFieldsMiscExpensesThirdYearData', this.otherFieldsMiscExpensesThirdYearData);
        //          console.log('misc', misc);

        // console.log('otherFieldsPayrollExpenses',this.otherFieldsPayrollExpenses);

        // IN ORDER TO HIDE NUMBERING INFRONT OF ADDOTHER BUTTON OF PAYROLLEXPENSES
        this.showPayrollNumbering = this.otherFieldsPayrollExpenses.length === 0;

        // IN ORDER TO HIDE NUMBERING INFRONT OF ADDOTHER BUTTON OF GENERALEXPENSES
        this.showGeneralNumbering = this.otherFieldsGeneralExpenses.length === 0;

        // IN ORDER TO HIDE NUMBERING INFRONT OF ADDOTHER BUTTON OF MISCEXPENSES
        this.showMiscNumbering = this.otherFieldsMiscExpenses.length === 0;

        this.payrollOtherValuesSum = payrollSum;
        this.payrollOtherValuesTotal = payroll.length;

        this.generalOtherValuesSum = generalSum;
        this.generalOtherValuesTotal = general.length;

        this.miscOtherValuesSum = miscSum;

        this.miscOtherValuesTotal = misc.length;

        this.payrollDataYearlyTotal =
          +this.payrollDataYearlyTotalForOther + +this.payrollDataYearlyTotal;

        this.generalDataYearlyTotal = +this.generalDataYearlyTotalForOther + +generalSum + +miscSum;

        this.parentObject.otherFieldsPayrollExpensesFirstYearData = this.otherFieldsPayrollExpensesFirstYearData;
        this.parentObject.otherFieldsPayrollExpensesSecondYearData = this.otherFieldsPayrollExpensesSecondYearData;
        this.parentObject.otherFieldsPayrollExpensesThirdYearData = this.otherFieldsPayrollExpensesThirdYearData;
        this.parentObject.otherFieldsGeneralExpenses = this.otherFieldsGeneralExpenses;
        this.parentObject.otherFieldsGeneralExpensesFirstYearData = this.otherFieldsGeneralExpensesFirstYearData;
        this.parentObject.otherFieldsGeneralExpensesSecondYearData = this.otherFieldsGeneralExpensesSecondYearData;
        this.parentObject.otherFieldsGeneralExpensesThirdYearData = this.otherFieldsGeneralExpensesThirdYearData;
        this.parentObject.otherFieldsMiscExpensesFirstYearData = this.otherFieldsMiscExpensesFirstYearData;
        this.parentObject.otherFieldsMiscExpensesSecondYearData = this.otherFieldsMiscExpensesSecondYearData;
        this.parentObject.otherFieldsMiscExpensesThirdYearData = this.otherFieldsMiscExpensesThirdYearData;

        if (this.otherFlag === true) {
          // this.projectService.updateTotalExpenses(data).subscribe();
          this.otherFlag = false;
        }
        this.otherEmitOpex.emit({ otherEmitOpex: true });
        // this.getOccupiedBedstenYearly();
        resolve(true);
      });
    });
  }

  // *************** REMOVE OTHER FIELDS******************/
  removeOtherField(id, child) {
    let array = [];
    const self = this;
    const data = {
      id,
      projectId: this.projectId,
      inflation_rate: this.inflation_rate,
      start_up_month: this.start_up_month,
      parent: 'operatingexpenses',
    };
    this.otherService.removeOtherField(data).subscribe((res) => {
      this.clearData();
      this.getOtherFields().then((success) => {
        if (child === 'payroll_expenses') {
          array = self.otherFieldsPayrollExpenses;
        } else if (child === 'general_expenses') {
          array = self.otherFieldsGeneralExpenses;
        } else if (child === 'misc_expenses') {
          array = self.otherFieldsMiscExpenses;
        }
        setTimeout(function () {
          document.getElementById(`label${child}${array.length - 1}`).focus();
        }, 100);
      });

      this.getOccupiedBeds();
    });
  }

  // *****************************UPDATE OTHER FIELDS VALUE ********************/
  updateFieldNameValue(id, event, field_name, child) {
    if (field_name === 'name') {
      const variableName = 'field_name';
      this.otherService
        .updateFieldNameValue(id, event.target.value, variableName)
        .subscribe((res) => {});
    } else {  // if (field_name === 'value') {
      const value: number = Number.parseInt(
        this.replaceDollarsCommasPercentages(event.target.value),
        10
      );
      const variableName = 'field_value';

      let data = {};
      if (child === 'payroll') {
        // IN ORDER TO GET SUM OF PAYROLL
        // The total for this miscellaneous value is the number of months in the specified year with a value. We don't have to deal with
        // inflation in this calculation because this entry that we're storing in the database is just the starting point, and there is
        // no inflation in the year that contains the starting point.
        const otherFieldsArrayPayroll: number = value * (this.year * 12 + 1 - this.start_up_month);
        data = {
          fieldName: 'payroll',
          value,
          total_other_payroll: otherFieldsArrayPayroll,
          project_id: this.projectId,
          inflation_rate: this.inflation_rate,
          start_up_month: this.start_up_month,
          year: this.year,
        };
      } else if (child === 'general') {
        // IN ORDER TO GET SUM OF GENERAL
        const otherFieldsArrayGeneral = value * 12;
        data = {
          fieldName: 'general',
          value,
          total_other_general: otherFieldsArrayGeneral,
          project_id: this.projectId,
          inflation_rate: this.inflation_rate,
          start_up_month: this.start_up_month,
          year: this.year,
        };
      } else if (child === 'opex') {
        // IN ORDER TO GET SUM OF OPEX
        // The total for this miscellaneous value is the number of months in the specified year with a value. We don't have to deal with
        // inflation in this calculation because this entry that we're storing in the database is just the starting point, and there is
        // no inflation in the year that contains the starting point.
        const otherFieldsArrayOpex = value * (this.year * 12 + 1 - this.start_up_month);
        data = {
          fieldName: 'opex',
          value,
          total_other_opex: otherFieldsArrayOpex,
          project_id: this.projectId,
          inflation_rate: this.inflation_rate,
          start_up_month: this.start_up_month,
          year: this.year,
        };
      } // TODO: Else display an error and don't do the update since we don't recognize the child that was specified.

      this.otherService.updateFieldNameValue(id, data, variableName).subscribe((res) => {
        // this.clearData();
        this.otherFlag = true;
        this.getOtherFields();
        this.getOccupiedBeds();
      });
    }
  }

  // ***************CLEAR ALL OTHER FIELDS ARRAY ******************/
  clearData() {
    this.otherFieldsPayrollExpenses = [];
    this.otherFieldsGeneralExpenses = [];
    this.otherFieldsMiscExpenses = [];
  }

  // ########################## END OD OTHER FIELDS TASKS #######################//

  // REMOVE , $ % . FROM THE INPUT ENTERED BY USER
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    $('body').toggleClass('navToggle');
    $('#pageContent').toggleClass('navToggle');
    //    $("#instructionsButton").effect( "shake", {times:4}, 1000 );
    this.showInstructions = !this.showInstructions;

    //
    // If we are stopping showing the instructions, change the text of the button back to "INSTRUCTIONS". If we are starting to show
    // the instructions, change the text of the button to "BACK TO MENU".
    //
    if (this.showInstructions) {
      $('#instructionsButton').text('BACK TO MENU');
      $('#instructionsButton').css('color', '#000000');
    } else {
      $('#instructionsButton').text('INSTRUCTIONS');
      $('#instructionsButton').css('color', '#FFFFFF');
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    $('body').toggleClass('navToggle');
    $('#pageContent').toggleClass('navToggle');
    $('#instructionsButton').text('INSTRUCTIONS');
    $('#instructionsButton').css('color', '#FFFFFF');
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/print-operatingexpenses/print-operatingexpenses.component.ts